import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { Feature, useSimpleFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { TOP_SUBCATEGORIES_ID } from "src/website-apps/responsive/stubhub-home/components/top-subcategories/constants";
import {
  CarouselId,
  CarouselItemType,
} from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { GridCardBase } from "src/website-apps/shared/components/grid-card-base";
import { HOME_CAROUSEL_IDS } from "src/website-apps/shared/components/responsive-carousel/constants";
import { ResponsiveCarousel } from "src/website-apps/shared/components/responsive-carousel/ResponsiveCarousel";
import { useCarouselDimensions } from "src/website-apps/shared/hooks/useCarouselDimensions";
import { TopSubcategoryCard } from "../TopSubcategoryCard";
import { topSubcategoriesListStyles } from "./top-subcategories-list.recipe";

const defaultSubcategories = [];

/**
 * Horizontal Scroll List for Top Subcategories UI in Mobile
 */
export const TopSubcategoriesList = ({ subcategories = defaultSubcategories, size }) => {
  const storePageEvent = useStorePageEvent();
  const isMobile = !useMediaQuery(Breakpoint.Tablet);

  const carouselDim = useCarouselDimensions(size);
  const isGridCardRefactorEnabled =
    useSimpleFeatureTernary(FeatureSetEnum.UseGridCardBaseComponentRefactor, false, true) ?? false;

  return (
    <ResponsiveCarousel
      size={carouselDim.carouselSize}
      items={subcategories}
      renderItem={(subcategory) => {
        const imageUrl = `https://img.vggcdn.net/img/top_category_images/2x/${subcategory.id}.jpeg`;
        return (
          <Feature
            id={FeatureSetEnum.UseGridCardBaseComponentRefactor}
            control={() => (
              <TopSubcategoryCard as="div" key={subcategory.id} imageSize={carouselDim.imageSize} {...subcategory} />
            )}
            variant={() => (
              <GridCardBase
                key={subcategory.id}
                {...subcategory}
                imageUrl={imageUrl}
                title={subcategory.text}
                classes={topSubcategoriesListStyles}
                size={isMobile ? "mobile" : "default"}
                fullHeightImage
                onClick={() => {
                  storePageEvent(PE_TYPE.CLICK, PE_KEYS.TOP_SUBCATEGORY_CARD_CLICK, String(subcategory.id));
                }}
              />
            )}
          />
        );
      }}
      hidePaginationButtons={isMobile}
      imageHeightHint={carouselDim.imageSize.height}
      carouselId={HOME_CAROUSEL_IDS.topSubcategories}
      viewName={TOP_SUBCATEGORIES_ID}
      useFlex={isGridCardRefactorEnabled}
      analyticsCarouselId={CarouselId.TopSubcategories}
      analyticsItemType={CarouselItemType.Category}
    />
  );
};
